export default {
  "ORDER_WAIT_SHIP": "Đang chờ giao hàng",
  "Men fashion": "Thời trang nam",
  "Shipping_details": "Chi tiết vận chuyển",
  "MyAccount_MyProfile_label_First": "Tên",
  "MyAccount_MyShippingDetails_Phone": "Số điện thoại",
  "Page_not_found_message1": "Xin lỗi, trang không tồn tại",
  "Help": "Trợ giúp",
  "Sign in": "Đăng nhập",
  "Register": "Đăng ký",
  "Category_sorting_Item": "Chọn cách sắp xếp",
  "cart_clear": "Xóa giỏ hàng",
  "Payment & Delivery": "Thanh toán và Vận chuyển",
  "Send my feedback": "Gửi phản hồi của tôi",
  "MyAccount_MyProfile_Save": "Lưu thay đổi",
  "Continue_billing": "Tiếp tục thanh toán",
  "Categories": "Danh mục",
  "Read and understand": "Tôi đã đọc và hiểu",
  "Feel free to edit": "Sửa bất kỳ thông tin chi tiết nào để luôn cập nhật tài khoản của bạn.",
  "Select payment method": "Chọn phương thức thanh toán",
  "cartPreviewSafety_messageinfo": "Giao hàng an toàn và nhanh chóng tới địa chỉ của bạn.",
  "Login_input_email": "email",
  "Login_input_first": "Tên",
  "Account": "Tài khoản",
  "Create_Time_Asc": "Thời gian tạo theo thứ tự tăng dần",
  "Order_No": "Mã đơn hàng",
  "MyAccount_Newsletter": "Thông tin đăng ký",
  "concactus_label": "Phản hồi hoặc câu hỏi",
  "Order_Grade": "Đánh giá đơn hàng",
  "wishlist_empty_desc": "Bạn chưa thêm bất kỳ sản phẩm nào vào danh sách yêu thích của mình.",
  "cartpreviewShipping_messageinfo": "Bạn sẽ nhận được thông báo vận chuyển và thời gian dự kiến giao hàng của đơn hàng của mình.",
  "unsubscribe": "Bạn có thể hủy đăng ký bất cứ lúc nào.",
  "prompt": "Thông báo",
  "MyAccount_MyProfile_yinsi_message": "Tại Brand name, chúng tôi rất quan tâm đến vấn đề bảo mật và cam kết bảo vệ dữ liệu cá nhân của người dùng. Để biết thêm thông tin về cách chúng tôi quan tâm và sử dụng dữ liệu cá nhân của bạn, hãy tham khảo",
  "About us": "Giới thiệu về chúng tôi",
  "or": "hay",
  "MyAccount_Order_History_All": "Tất cả đơn hàng",
  "What_We_Improve": "Chúng tôi cải tiến như thế nào?",
  "MyAccount_ShippingDetails_title": "Chi tiết vận chuyển",
  "MyAccount_Order_History_Tabs2": "Chưa thanh toán",
  "Go_back_shopping": "Quay trở lại mua sắm",
  "Product": "Sản phẩm",
  "Order summary": "Tóm tắt đơn hàng",
  "payment_order_total": "Tổng số tiền đơn hàng",
  "Departments": "Phiên bản tiếng Việt và Điều khoản sử dụng",
  "Download": "Tải xuống",
  "Your_Purchase_Order": "Đơn hàng mua sắm của bạn",
  "Your_Account": "Tài khoản của bạn",
  "order_after_sales_list_null": "Bạn chưa có đơn hàng sau bán hàng nào.",
  "All_After_sales_orders": "Tất cả đơn hàng sau bán hàng",
  "Filters": "Lọc",
  "search_results_not": "Chúng tôi không tìm thấy kết quả liên quan đến cụm từ đã cho",
  "ORDER_WAIT_RECEIPT": "Chờ nhận hàng",
  "ORDER_CLOSED": "Đã đóng",
  "Order_View_details": "Xem chi tiết",
  "Subscribe_to_message": "Cập nhật về các đợt giảm giá và sự kiện sắp tới. Nhận quà tặng và ưu đãi đặc biệt!",
  "TaxFee": "Thuế và phí",
  "Apply": "Áp dụng",
  "Total_price": "Tổng giá trị",
  "Description": "Mô tả",
  "Payment method": "Phương thức thanh toán",
  "Back": "Quay lại",
  "Empty": "Dường như bạn chưa thêm sản phẩm nào vào giỏ hàng của mình. Hãy bắt đầu mua sắm để điền vào nó.",
  "After_sales": "Sau khi mua sắm",
  "Instruction3": "Vâng, chúng tôi hiểu rồi",
  "MyAccount_MyShippingDetails_Last": "Họ và tên đệm",
  "MyAccount_MyShippingDetails_City": "Thành phố",
  "payment_order_discount": "Chiết khấu đơn hàng",
  "MyAccount_Order": "Chi tiết đơn hàng",
  "ID_Name_Error": "Vui lòng nhập tên trên thẻ căn cước",
  "Kidswear": "Quần áo trẻ em",
  "Share your look": "Chia sẻ trang phục của bạn",
  "Pay_Order": "Thanh toán đơn hàng",
  "Reset_Password": "Thiết lập lại mật khẩu",
  "MyAccount_MyProfile_label2_pass1": "Mật khẩu hiện tại",
  "Create_Time_Desc": "Thời gian tạo đơn giảm dần",
  "Items": "Sản phẩm",
  "Login_Register": "Đăng ký ngay",
  "Back to homepage": "Quay lại trang chủ",
  "switch_CNY": "Chuyển sang đồng nhân dân tệ",
  "Successful placed order": "Bạn đã đặt hàng thành công. Bạn có thể sử dụng tính năng Trạng thái Giao hàng của chúng tôi để kiểm tra trạng thái đơn hàng. Bạn sẽ nhận được một email xác nhận đơn hàng chứa thông tin chi tiết và liên kết theo dõi.",
  "MyAccount_MyProfile_yinsi_link": "Chính sách bảo mật",
  "Order_Date": "Ngày đặt hàng",
  "Allow order notifications": "Cho phép thông báo đơn hàng",
  "MyAccount_MyProfile_Tab1": "Hồ sơ cá nhân",
  "MyAccount_ShippingDetails_changeTitle": "Thay đổi địa chỉ",
  "ID_Number": "Số CMTND/CCCD/Hộ chiếu",
  "Order_after_sales_message": "Chi tiết đơn hàng và đơn hàng sau khi mua sắm",
  "MyAccount_MyProfile_title2": "Nếu bạn muốn đổi mật khẩu để truy cập tài khoản của mình, hãy nhập thông tin sau đây:",
  "cartPreviewSafety": "Giao hàng an toàn",
  "Customer service": "Dịch vụ khách hàng",
  "MyAccount_MyProfile_Update": "Cập nhật mật khẩu",
  "choose_language": "Chọn ngôn ngữ",
  "ORDER_REFUNDING": "Đang hoàn tiền",
  "MyAccount_MyProfile_title1": "Bạn có thể chỉnh sửa bất kỳ thông tin chi tiết nào dưới đây để đảm bảo tài khoản của bạn luôn được cập nhật:",
  "ORDER_WAIT_RATE": "Đánh giá sau khi mua sắm",
  "after_sales_refund_order": "Hoàn tiền đơn hàng",
  "Who we are": "Chúng tôi là ai",
  "Women fashion": "Thời trang nữ",
  "Personal details": "Chi tiết cá nhân",
  "Password": "Mật khẩu",
  "wishlist_empty_title": "Danh sách mong muốn của bạn đang trống",
  "Shipping": "Giao hàng",
  "Repeat_Password": "Nhập lại mật khẩu",
  "cart_price": "Tổng cộng",
  "Sort_by": "Sắp xếp theo",
  "Customer Reviews": "Đánh giá khách hàng",
  "Continue to shipping": "Tiếp tục vận chuyển",
  "payment_make_order": "Đặt hàng",
  "MyAccount_Profile": "Hồ sơ",
  "MyAccount_Wishlist": "Danh sách mong muốn",
  "save_order_review": "Gửi đánh giá",
  "Save_Password": "Lưu mật khẩu",
  "cart_empty_title": "Giỏ hàng của bạn đang trống",
  "TopBar_help": "Trợ giúp & Câu hỏi thường gặp",
  "colseCookie": "Tôi hiểu rồi",
  "Password_Changed": "Mật khẩu đã được thay đổi thành công. Bây giờ bạn có thể trở lại trang chủ và đăng nhập.",
  "Forgot Password Modal Email": "Email bạn sử dụng để đăng nhập:",
  "MyAccount_Personal": "Chi tiết cá nhân",
  "cartPreviewShipping": "Vận chuyển tiện lợi",
  "ORDER_AFTER_SALE": "Sau khi bán hàng",
  "Page_not_found": "Không tìm thấy trang",
  "Find out more": "Tìm hiểu thêm",
  "Log into your account": "Đăng nhập vào tài khoản của bạn",
  "Details_and_status_orders": "Kiểm tra thông tin chi tiết và trạng thái đơn đặt hàng của bạn tại cửa hàng trực tuyến. Bạn cũng có thể hủy đơn hàng hoặc yêu cầu trả hàng.",
  "MyAccount_MyShippingDetails_Street": "Đường",
  "Order_to_be_paid_message": "Chưa thanh toán",
  "Guarantee": "Đảm bảo",
  "Sections that interest you": "Các phần bạn quan tâm",
  "payment_post_tax": "Thuế phí gửi hàng",
  "ORDER_PAID": "Đã thanh toán",
  "concactus_label5": "Họ và tên",
  "Item": "Sản phẩm",
  "Go_back": "Quay lại",
  "more": "Thêm",
  "MyAccount": "Tài khoản của tôi",
  "payment_agree_1": "Tôi đồng ý",
  "total_items": "Tổng số sản phẩm",
  "shopping_go": "Quản lý địa chỉ giao hàng",
  "ID_Type": "Loại thẻ căn cước/CMND",
  "MyAccount_MyShippingDetails_HouseNumber": "Số nhà",
  "after_sales_status": "Trạng thái sau khi bán hàng",
  "After_sales_apply": "yêu cầu bán hàng sau",
  "Login": "Đăng nhập",
  "Quantity": "Số lượng",
  "payment_post_fee": "Phí vận chuyển",
  "MyAccount_Log_out": "Đăng xuất",
  "Subtotal": "Tạm tính",
  "forgotPasswordConfirmation": "Cảm ơn bạn! Nếu bạn đã đăng ký tài khoản với địa chỉ email {0}, bạn sẽ nhận được một thông báo chứa liên kết đặt lại mật khẩu trong hộp thư đến của mình.",
  "MyAccount_Order_History_Tabs1": "Lịch sử đơn hàng của tôi",
  "concactus_img": "Tải ảnh lên",
  "Done": "Hoàn thành",
  "Info after order": "Bạn có thể đăng nhập vào tài khoản của mình bằng email và mật khẩu đã được định nghĩa trước. Trong tài khoản của mình, bạn có thể chỉnh sửa hồ sơ cá nhân, xem lịch sử giao dịch, chỉnh sửa đăng ký thông tin liên lạc, v.v.",
  "MyAccoubnt_Set_newsletter": "Thiết lập thông tin bản tin của bạn, chúng tôi sẽ gửi cho bạn sản phẩm mới và các thông tin xu hướng được lựa chọn hàng tuần. ",
  "Shipping_method": "Phương thức vận chuyển",
  "after_sales_refund": "Số tiền hoàn lại",
  "After_sales_save": "Lưu thông tin hậu mãi",
  "go_order_history": "Xem lịch sử đặt hàng",
  "contactus_message_placeholder": "Vui lòng nhập tin nhắn hoặc câu hỏi của bạn",
  "Login_Forgot_Password": "Nếu bạn không thể nhớ mật khẩu, bạn có thể đặt lại mật khẩu.",
  "show_more": "Xem thêm",
  "MyAccount_MyProfile_label_email": "email",
  "MyAccount_MyProfile_label2_pass3": "Lặp lại mật khẩu",
  "Products": "Sản phẩm",
  "Review": "Đánh giá",
  "MyAccount_MyProfile_title3": "Địa chỉ email hiện tại của bạn là",
  "Category_found_Products": "Sản phẩm được tìm thấy",
  "Match": "Phối đồ",
  "Read_all_reviews": "Đọc tất cả các đánh giá",
  "See_all": "Tất cả",
  "Commercial information": "Tôi đồng ý và chấp nhận nhận thông tin thương mại được tùy chỉnh từ Brand name qua email",
  "Change password your account": "Nếu bạn muốn thay đổi mật khẩu truy cập vào tài khoản, vui lòng nhập thông tin sau",
  "MyAccount_History": "Lịch sử đặt hàng",
  "ID_Name": "Tên trên ID",
  "All": "Tất cả",
  "Instruction2": "Bạn chỉ muốn hướng dẫn bảo dưỡng?",
  "MyAccount_ShippingDetails_Add": "Thêm địa chỉ mới",
  "MyAccount_MyShippingDetails_Zip": "Mã bưu điện",
  "go_pay_order": "Đi đến thanh toán",
  "Thank_You_Inbox": "Nếu thông báo không nằm trong hộp thư đến của bạn, vui lòng thử một địa chỉ email khác có thể bạn đã sử dụng để đăng ký.",
  "Subscribe": "Đăng ký",
  "confirm_subscription": "Tôi xác nhận đăng ký",
  "Login_input_Remember": "Ghi nhớ đăng nhập",
  "Add to compare": "Thêm vào so sánh",
  "Brand": "Thương hiệu",
  "Start_shopping": "Bắt đầu mua sắm",
  "Select shipping method": "Chọn phương thức vận chuyển",
  "address CN": "Địa chỉ ở Trung Quốc, tiền tệ hiện tại phải là đồng nhân dân tệ",
  "MyAccount_MyShippingDetails_State": "Bang / Tỉnh",
  "Page_not_found_message2": "Vui lòng quay lại hoặc thử lại",
  "Go_to_checkout": "Đi đến thanh toán",
  "See all results": "Xem tất cả các kết quả",
  "search_results_inputnull": "Bạn chưa tìm kiếm sản phẩm nào.",
  "subscribeToNewsletterModalContent": "Sau khi đăng ký thông tin đăng ký của bạn, bạn sẽ nhận được các ưu đãi đáng chú ý và thông tin từ VSF qua email. Chúng tôi không bán hoặc phân phối email của bạn cho bất kỳ bên thứ ba nào tại bất kỳ thời điểm nào. Vui lòng tham khảo {0} của chúng tôi.",
  "Download all": "Tải xuống tất cả",
  "Login_input_last": "Họ",
  "Amount": "Số tiền",
  "ORDER_WAIT_PAYMENT": "Chờ thanh toán",
  "Order_After_sales": "Sau khi bán hàng",
  "concattus_button": "Đệ trình",
  "Shipping_valid_required": "Trường này là bắt buộc",
  "Price": "Giá tiền",
  "Search_items": "Tìm kiếm",
  "ID_Type_Error": "Vui lòng chọn loại thẻ căn cước của bạn",
  "Order_Status": "Trạng thái đơn hàng",
  "Payment methods": "Phương thức thanh toán",
  "MyAccount_MyProfile_Tab2": "Thay đổi mật khẩu",
  "Show on page": "Hiển thị trên trang",
  "Edit": "Chỉnh sửa",
  "Change": "Thay đổi",
  "MyAccount_ShippingDetails_Update": "Cập nhật địa chỉ",
  "View": "Xem",
  "Privacy": "Riêng tư",
  "Enter_promo_code": "Nhập mã khuyến mãi",
  "Discount": "Giảm giá",
  "Delete": "Xóa",
  "Wishlist": "Danh sách yêu thích",
  "MyAccount_Order_History_Tabs3": "Trả hàng",
  "Go_To_Order_review": "Đi đến đánh giá",
  "Update personal data": "Cập nhật dữ liệu cá nhân",
  "payment_agree_2": "Các điều khoản và điều kiện",
  "or fill the details below": "Hoặc điền chi tiết bên dưới",
  "Contact details updated": "Giữ cho địa chỉ và thông tin liên hệ của bạn luôn được cập nhật.",
  "Login_Create": "Tạo tài khoản",
  "Payment": "Thanh toán",
  "Billing": "Thanh toán",
  "payment_insurance_tax": "Tiền bảo hiểm thuế",
  "Size guide": "Hướng dẫn chọn size",
  "Login_forgotten_password": "Quên mật khẩu?",
  "Login_no_account": "Chưa có tài khoản?",
  "Privacy_Policy": "Chính sách bảo mật",
  "BootomCookieTitle": "Cho phép cookie",
  "Use your personal data": "Tại Brand name, chúng tôi đặt mối quan tâm lớn đến việc bảo vệ dữ liệu cá nhân của người dùng. Để tìm hiểu thêm thông tin về cách chúng tôi quan tâm và sử dụng dữ liệu cá nhân của bạn, vui lòng xem",
  "Review my order": "Xem đơn hàng của tôi",
  "BootomCookieLink": "Tìm hiểu thêm",
  "hide": "Ẩn",
  "MyAccount_ShippingDetails_message_title": "Quản lý tất cả các địa chỉ giao hàng bạn muốn (địa chỉ công ty, địa chỉ nhà...) để bạn không cần phải nhập địa chỉ giao hàng bằng tay trong mỗi đơn đặt hàng.",
  "Purchase terms": "Điều khoản mua hàng",
  "Billing_address": "Thanh toán",
  "Manage shipping addresses": "Quản lý tất cả các địa chỉ giao hàng bạn muốn (địa chỉ công ty, địa chỉ nhà...) để bạn không cần phải nhập địa chỉ giao hàng bằng tay trong mỗi đơn đặt hàng.",
  "login_logbtn": "Đăng nhập",
  "choose_currency": "Chọn loại tiền tệ",
  "ORDER_REFUNDED": "Đã hoàn lại tiền",
  "After_sales_form": "Điền vào biểu mẫu hậu mãi",
  "add_To_Wishlist": "Thêm vào danh sách yêu thích",
  "search_results_inputnull2": "Hãy bắt đầu ngay bây giờ, chúng tôi sẽ giúp bạn.",
  "Shipping_title": "Địa chỉ nhận hàng",
  "Total": "Tổng cộng",
  "Subscribe_to_newsletter": "Đăng ký bản tin",
  "Shipping_valid_Phone": "Vui lòng nhập số điện thoại hợp lệ",
  "concactus_label3": "Tiêu đề",
  "Manage billing addresses": "Quản lý tất cả địa chỉ thanh toán mà bạn muốn (địa chỉ nơi làm việc, địa chỉ gia đình...) để bạn không phải nhập địa chỉ thanh toán thủ công cho mỗi đơn hàng.",
  "Search_results_title": "Kết quả tìm kiếm",
  "payment_order_payment": "Thanh toán đơn hàng",
  "after_sales_Id": "ID hoàn trả",
  "cart_title": "Giỏ hàng của tôi",
  "Order_Detail": "Chi tiết đơn hàng",
  "concactus_label2": "Liên kết cửa hàng",
  "Shipping_valid_length_min": "Trường này phải có ít nhất {min} ký tự",
  "Product suggestions": "Đề xuất sản phẩm",
  "Return_home": "Trở về trang chủ",
  "Quality in the details": "Chất lượng tinh tế",
  "Continue_to_payment": "Tiếp tục thanh toán",
  "Feedback": "Ý kiến phản hồi của bạn rất quan trọng đối với chúng tôi. Vui lòng cho chúng tôi biết chúng tôi có thể cải thiện điều gì.",
  "Go back to shop": "Trở lại cửa hàng",
  "Back_to_home": "Quay lại trang chủ",
  "Review_Content": "Nội dung đánh giá",
  "add_To_Cart": "Thêm vào giỏ hàng",
  "Read_reviews": "Đọc đánh giá",
  "Instruction1": "Cách chăm sóc",
  "Email_address": "Địa chỉ email",
  "Category_Item_List": "Bật/xem dưới dạng danh sách",
  "Same as shipping address": "Giống địa chỉ giao hàng",
  "Category_Item_Grid": "Bật/xem dưới dạng lưới",
  "ID_Number_Error": "Vui lòng nhập số CMND của bạn",
  "concactus_label4": "Email liên hệ",
  "Additional_info": "Thông tin bổ sung",
  "add_shipping": "Thêm địa chỉ giao hàng mới",
  "Product_description": "Thiết kế cổ V của Karissa Tee phù hợp với nhiều dáng người. Nó ôm sát đường cong của bạn, che đi các vùng \"khó khăn\" thông thường, giúp bạn tự tin vào phòng tập. Còn có váy dạ hội đầy ấn tượng và đầm tiệc tùng cho phụ nữ.",
  "Login_create_account": "Tôi đồng ý với các điều khoản và chính sách bảo mật",
  "after_sales_Reason": "Lý do hoàn trả hàng",
  "MyAccount_MyProfile_label_Last": "Họ và tên",
  "MyAccount_MyProfile_label2_pass2": "Mật khẩu mới",
  "Save": "Lưu",
  "CartSliderTextBtn": "Lưu vào danh sách mua sau",
  "Color": "Màu sắc",
  "Shipping_Tax": "Phí vận chuyển và thuế",
  "Subscribe_to_success": "Bạn đã đăng ký",
  "Enjoy your free account": "Hãy tận hưởng các đặc quyền tài khoản miễn phí của bạn!",
  "cart_empty_desc": "Dường như bạn chưa thêm bất kỳ sản phẩm nào vào giỏ hàng. Bắt đầu mua sắm để điền vào nó.",
  "MyAccount_ShippingDetails_message_title2": "Hãy giữ địa chỉ và thông tin liên lạc của bạn cập nhật.",
  "An_error_occured": "Đã xảy ra lỗi",
  "Country": "Quốc gia/Khu vực",
  "MyAccount_MyShippingDetails_First": "Tên",
  "payment_insurance_fee": "Phí bảo hiểm",
  "Home": "Trang chủ",
  "Contact_us": "Liên hệ chúng tôi",
  "Cookies Policy": "Chính sách cookie",
  "match_goods": "Hàng hóa bán chạy",
  "Clear all": "Xóa tất cả",
  "Basket": "Giỏ hàng",
  "MyAccount_MyProfile_reqeatPassErrMsg": "Mật khẩu mới không khớp",
  "Your current email address is": "Địa chỉ email hiện tại của bạn là",
  "You currently have no orders": "Hiện tại bạn không có đơn hàng nào",
  "Login_input_password": "Mật khẩu",
  "Promo_code": "Mã khuyến mại",
  "order_count": "Số đơn hàng",
  "email_geshi_error": "Vui lòng nhập địa chỉ email hợp lệ",
  "your_email": "Email của bạn",
  "email": "Email",
  "you_have_subscribed": "Bạn đã đăng ký",
  "cancel_Subscribe": "Hủy đăng ký",
  "save_and_pay": "Lưu và thanh toán",
  "hasInsurance": "Có mua bảo hiểm không?",
  "pleasePayType": "Vui lòng chọn phương thức thanh toán",
  "zhuanfa_toBePay": "Chuyển cho bạn bè trả tiền giúp bạn",
  "linkCopied": "Đã sao chép liên kết, hãy chia sẻ với bạn bè ngay bây giờ",
  "Links": "Liên kết",
  "article_category": "Danh mục",
  "wechat_code_login_message": "Vui lòng sử dụng máy quét mã QR WeChat để đăng nhập",
  "wechat_code_login": "Đăng nhập với WeChat",
  "Api_Update_success": "Cập nhật thành công",
  "Please_Use_WeChat_login": "Vui lòng sử dụng WeChat để đăng nhập",
  "mobile_geshi_error": "Vui lòng nhập số điện thoại hợp lệ",
  "Login_input_email_required": "Vui lòng nhập địa chỉ email",
  "article_null": "Chưa có bài viết",
  "Login_with_microsoft": "Đăng nhập Microsoft",
  "article_null_des": "Bạn có thể duyệt qua các danh mục khác của bài viết",
  "register_email": "Email",
  "Login_tab_email": "Email",
  "code.time": "{time} giây để thử lại",
  "Login_with_wechat": "Đăng nhập với WeChat",
  "cat_items_null_des": "Bạn có thể duyệt qua các danh mục khác của đồ vật",
  "Login_with_facebook": "Đăng nhập với facebook",
  "Login_input_code": "Mã xác nhận",
  "Login_input_mobile_required": "Vui lòng nhập số điện thoại",
  "Login_input_mobile": "Số điện thoại",
  "cat_items_null": "Hiện tại chưa có hàng hóa nào trong danh mục này",
  "Login_with_twitter": "Đăng nhập Twitter",
  "mobile_code": "Mã xác nhận",
  "register_mobile": "Số điện thoại",
  "Login_tab_mobile": "Số điện thoại",
  "Login_with_google": "Đăng nhập Google",
  "OrderSku": "Thông tin đặt hàng",
  "Order_logisticsNo": "Số lượng vận chuyển hàng hóa",
  "order_shopping_firstname": "Tên thật",
  "Order_logisticsName": "Tên công ty vận chuyển hàng hóa",
  "ItemPrice": "Giá sản phẩm",
  "inPayOrderAll": "Danh sách chờ thanh toán",
  "payPrice": "Giá thanh toán",
  "shipping_add_success": "Thêm địa chỉ nhận hàng thành công",
  "pay_code_refresh": "Làm mới mã thanh toán",
  "pay_code_shixiao": "Mã thanh toán đã hết hiệu lực",
  "concactus_title": "Liên hệ chúng tôi",
  "WebAutoLang": "Ngôn ngữ được đề xuất hiện tại của trình duyệt là: {lang}，Bạn có muốn chuyển sang ngôn ngữ này không?",
  "Services_Name": "Tên dịch vụ",
  "Services_Price": "Giá dịch vụ",
  "SwichLang": "Chuyển đổi ngôn ngữ",
  "Services_Description": "Mô tả dịch vụ",
  "goodinfo_null": "Không có sản phẩm nào",
  "goodinfo_null_des": "Bạn có thể xem sản phẩm trong các danh mục khác",
  "notYetUseCode": "Chưa sử dụng mã giảm giá",
  "guest_Login": "Đăng nhập dưới dạng khách",
  "billing_and_shipping": "Hóa đơn và địa chỉ nhận hàng giống nhau",
  "select_coupon": "Chọn phiếu giảm giá",
  "select_gift": "Chọn quà tặng",
  "currentUseCode": "Đã sử dụng mã giảm giá",
  "shipping_refresh": "Làm mới danh sách",
  "bind_microsoft": "Liên kết với Microsoft",
  "bind_twitter": "Liên kết với Twitter",
  "bind_facebook": "Liên kết với Facebook",
  "bind_wechat_code": "Mã QR WeChat",
  "bind_wechat": "Liên kết với WeChat",
  "bind_google": "Liên kết với Google",
  "Wishlist_Empty": "Không có danh sách mong muốn nào",
  "discount_post_fee": "Giảm giá phí vận chuyển",
  "ORDER_PART_PAID": "Thanh toán một phần",
  "discount_kou": "Giảm giá {discount}",
  "claimCoupone": "Nhận phiếu",
  "claimCouponeSuccess": "Nhận {name} thành công",
  "Offline_payment": "Thanh toán ngoại tuyến",
  "shopName": "Tên cửa hàng",
  "Social": "Mạng xã hội",
  "SERVICE": "Dịch vụ",
  "onlineContact": "Liên hệ trực tuyến",
  "confirm": "Xác nhận",
  "closeOrder": "Hủy đơn hàng",
  "closeOrderContext": "Bạn có chắc muốn hủy đơn hàng?",
  "Message_Read": "Đã đọc",
  "close.order.success": "Đã hủy đơn hàng thành công",
  "shippingAddress": "Địa chỉ chi tiết",
  "Message": "tin nhắn",
  "Message_Empty_Title": "tin nhắn của bạn đang trống",
  "MyAccount_Message": "tin nhắn",
  "Message_Empty": "Không có tin nhắn",
  "payment_order_note": "ghi chú đơn hàng",
  "go_to_see_prepid": "Nhấp vào đây để xem các đơn hàng chưa thanh toán",
  "operate": "Hoạt động",
  "removeCartItemContext": "Bạn có chắc muốn xóa {title} không?",
  "shippingItemQty": "Số lượng vận chuyển",
  "removeCartItem": "Xóa sản phẩm",
  "shippingInfo": "Thông tin vận chuyển",
  "Distributor_success": "Đã thành công cho nhà phân phối",
  "Distributor_apply": "Đăng ký trở thành nhà phân phối",
  "Distributor_Details": "Nhà phân phối",
  "DistributorSataus": "Trạng thái",
  "Distributor_Details_Empty": "Không có nhà phân phối tạm thời",
  "distributor.status.4": "Đã hủy bỏ",
  "distributor.status.1": "Không xem xét",
  "Distributor_copy_url": "Sao chép liên kết phân phối",
  "Order_Time": "Thời gian đặt hàng",
  "Order_User": "Người đặt hàng",
  "Distributor_copy_success": "Sao chép thành công",
  "distributor.status.3": "Đã thanh toán",
  "MyAccount_Distributor": "Nhà phân phối",
  "MyAccoubnt_Set_Distributor": "Đăng ký trở thành nhà phân phối",
  "distributor.status.2": "Chờ thanh toán",
  "DistributorAmount": "Hoa hồng",
  "Distributor_shenheshibai": "Đã được bảo lưu lại bởi nhà phân phối",
  "Distributor_shenhezhong": "Đang được xử lý bởi nhà phân phối",
  "Distributor_Order_Empty": "Không có đơn hàng phân phối",
  "NE": "Niger",
  "DJ": "Djibouti",
  "KP": "Bắc Triều Tiên",
  "US": "Hoa Kỳ",
  "LC": "Saint Lucia",
  "NL": "Hà Lan",
  "CD": "Cộng hòa Dân chủ Congo",
  "IS": "Iceland",
  "MA": "Maroc",
  "GH": "Ghana",
  "KR": "Hàn Quốc",
  "MK": "chứt",
  "HT": "Haïti",
  "PF": "Polynésie thuộc Pháp",
  "GA": "Gabon",
  "TD": "Tchad",
  "LB": "Liban",
  "CG": "Congo",
  "KG": "Kyrgyzstan",
  "TA": "Tristan da Cunha",
  "KW": "Kuwait",
  "TL": "Đông Timor",
  "IN": "Ấn Độ",
  "NO": "Na Uy",
  "NG": "Nigeria",
  "AQ": "Nam Cực",
  "LY": "Libya",
  "NI": "Nicaragua",
  "TT": "Trinidad và Tobago",
  "HM": "Quần đảo Heard và McDonald",
  "PY": "Paraguay",
  "BA": "Bosna và Hercegovina",
  "JP": "Nhật Bản",
  "MD": "Moldova",
  "MT": "Malta",
  "RE": "Réunion",
  "UG": "Uganda",
  "SB": "Quần đảo Solomon",
  "SL": "Sierra Leone",
  "CV": "Cape Verde",
  "SD": "Sudan",
  "FO": "Quần đảo Faroe",
  "ZA": "Nam Phi",
  "TR": "Thổ Nhĩ Kỳ",
  "FK": "Quần đảo Falkland",
  "PA": "Panama",
  "GF": "Guiana thuộc Pháp",
  "TJ": "Tajikistan",
  "NC": "New Caledonia",
  "PM": "Saint Pierre và Miquelon",
  "NU": "Niue",
  "AO": "Angola",
  "VN": "Việt Nam",
  "GN": "Guinea",
  "MW": "Malawi",
  "BY": "Belarus",
  "IM": "Đảo Man",
  "BI": "Burundi",
  "BS": "Bahamas",
  "CK": "Quần đảo Cook",
  "MH": "Quần đảo Marshall",
  "CR": "Costa Rica",
  "HK": "Hồng Kông, Trung Quốc",
  "AD": "Andorra",
  "BN": "Brunei Darussalam",
  "SN": "Senegal",
  "AE": "Các tiểu vương quốc Ả Rập Thống nhất",
  "GI": "Gibraltar",
  "CA": "Canada",
  "AX": "Quần đảo Åland",
  "UY": "Uruguay",
  "WF": "Wallis và Futuna",
  "GM": "Gambia",
  "SO": "Somalia",
  "RU": "Nga",
  "PL": "Ba Lan",
  "FM": "Micronesia",
  "ET": "Ethiopia",
  "EE": "Estonia",
  "SK": "Slovakia",
  "AS": "American Samoa",
  "ZM": "Zambia",
  "AL": "Albania",
  "AT": "Austria",
  "VA": "Vatican City",
  "TW": "Đài Loan, Trung Quốc",
  "BD": "Bangladesh",
  "AR": "Argentina",
  "EH": "Western Sahara",
  "MO": "Macao SAR China",
  "MV": "Maldives",
  "GU": "Guam",
  "AW": "Aruba",
  "AI": "Anguilla",
  "CL": "Chile",
  "IL": "Israel",
  "GD": "Grenada",
  "WS": "Samoa",
  "SE": "Thụy Điển",
  "GP": "Guadeloupe",
  "YE": "Yemen",
  "GT": "Guatemala",
  "BG": "Bulgaria",
  "SJ": "Svalbard and Jan Mayen",
  "CO": "Colombia",
  "LS": "Lesotho",
  "LV": "Latvia",
  "UM": "U.S. Outlying Islands",
  "MX": "Mexico",
  "DO": "Dominican Republic",
  "PE": "Peru",
  "HN": "Honduras",
  "TC": "Turks and Caicos Islands",
  "VI": "U.S. Virgin Islands",
  "FJ": "Fiji",
  "MP": "Northern Mariana Islands",
  "AC": "Ascension Island",
  "NA": "Namibia",
  "SZ": "Swaziland",
  "RW": "Rwanda",
  "BH": "Bahrain",
  "KN": "Saint Kitts and Nevis",
  "TN": "Tunisia",
  "AF": "Afghanistan",
  "VG": "Quần đảo Virgin, thuộc Anh quốc",
  "KE": "Kenya",
  "PK": "Pakistan",
  "GL": "Greenland",
  "SY": "Syria",
  "CU": "Cuba",
  "RS": "Serbia",
  "BF": "Burkina Faso",
  "BM": "Bermuda",
  "BZ": "Belize",
  "SV": "El Salvador",
  "CN": "Trung Quốc",
  "MF": "Saint Martin",
  "NF": "Đảo Norfolk",
  "MZ": "Mozambique",
  "LU": "Luxembourg",
  "TO": "Tonga",
  "GR": "Hy Lạp",
  "SI": "Slovenia",
  "PW": "Palau",
  "TZ": "Tanzania",
  "IR": "Iran",
  "GG": "Guernsey",
  "SM": "San Marino",
  "TF": "Lãnh thổ Nam Cực nước Pháp",
  "PS": "Palestine",
  "SC": "Seychelles",
  "BT": "Bhutan",
  "JM": "Jamaica",
  "BR": "Brazil",
  "CH": "Thụy Sĩ",
  "SH": "Saint Helena",
  "HU": "Hungary",
  "TM": "Turkmenistan",
  "LT": "Lithuania",
  "MC": "Monaco",
  "LI": "Liechtenstein",
  "LR": "Liberia",
  "GE": "Georgia",
  "SA": "Saudi Arabia",
  "GB": "Vương quốc Anh",
  "VE": "Venezuela",
  "MU": "Mauritius",
  "HR": "Croatia",
  "SR": "Suriname",
  "CM": "Cameroon",
  "IQ": "Iraq",
  "BO": "Bolivia",
  "MN": "Mông Cổ",
  "DZ": "Algeria",
  "TK": "Tokelau",
  "MG": "Madagascar",
  "YT": "Mayotte",
  "CC": "Cocos Islands",
  "LA": "Laos",
  "PT": "Portugal",
  "QA": "Qatar",
  "AN": "Netherlands Antilles",
  "PN": "Pitcairn Islands",
  "ES": "Spain",
  "VC": "Saint Vincent and the Grenadines",
  "AU": "Australia",
  "CX": "Christmas Island",
  "KM": "Comoros",
  "MR": "Mauritania",
  "FR": "France",
  "SG": "Singapore",
  "BV": "Bouvet Island",
  "PH": "Philippines",
  "CY": "Cyprus",
  "TV": "Tuvalu",
  "CF": "Central Africa",
  "EC": "Ecuador",
  "GW": "Guinea-Bissau",
  "IE": "Ireland",
  "LK": "Sri Lanka",
  "ER": "Eritrea",
  "GQ": "Equatorial Guinea",
  "NP": "Nepal",
  "BE": "Belgium",
  "GY": "Guyana",
  "DK": "Denmark",
  "MQ": "Martinique",
  "UZ": "Uzbekistan",
  "CI": "Ivory Coast (Cote d'Ivoire)",
  "ID": "Indonesia",
  "BJ": "Benin",
  "ST": "Sao Tome and Principe",
  "KH": "Cambodia",
  "KZ": "Kazakhstan",
  "MS": "Montserrat",
  "TH": "Thailand",
  "FI": "Finland",
  "ML": "Mali",
  "AM": "Armenia",
  "IT": "Italy",
  "NR": "Nauru",
  "PG": "Papua New Guinea",
  "ZW": "Zimbabwe",
  "JO": "Jordan",
  "OM": "Oman",
  "ME": "Montenegro",
  "JE": "Jersey",
  "NZ": "New Zealand",
  "VU": "Vanuatu",
  "DE": "Germany",
  "CZ": "Czech Republic",
  "DM": "Dominica",
  "KY": "Cayman Islands",
  "BW": "Botswana",
  "RO": "Romania",
  "PR": "Puerto Rico",
  "AZ": "Azerbaijan",
  "IO": "British Indian Ocean Territory",
  "UA": "Ukraine",
  "TG": "Togo",
  "MY": "Malaysia",
  "AG": "Antigua and Barbuda",
  "EG": "Egypt",
  "GS": "South Georgia and the South Sandwich Islands",
  "MM": "Myanmar",
  "BB": "Barbados",
  "KI": "Kiribati",
  "All_Country": "Tất cả",
  "post_state_country": "Phí giao hàng: {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "Giao hàng đến",
  "ShippingFee": "Phí vận chuyển",
  "reviewOutOf": "{rating} sao, tổng cộng 5 sao",
  "product.pifa.label": "Mua {startnum} - {endnum} món",
  "product.pifa.type.1": "Giảm giá",
  "Write_a_review": "Viết bình luận",
  "BasedOnTotalReviews": "Dựa trên {total} đánh giá",
  "product.wholesale": "Giá bán buôn",
  "reviewMostRecent": "Đánh giá mới nhất",
  "product.pifa.type.2": "Đơn giá",
  "product.num.danwei": "cái",
  "good.shoppingDateLabel": "Thời gian giao hàng",
  "good.shippingPeriod": "Giao hàng trong n ngày",
  "emailError": "Định dạng email sai",
  "addressNote": "Chú thích địa chỉ",
  "Concactus": "Liên hệ",
  "addressMessage": "Vui lòng đảm bảo địa chỉ của bạn chính xác và không có lỗi. Sau khi thanh toán, chúng tôi sẽ không thể thay đổi địa chỉ.",
  "showOrderSummary": "Tóm tắt đơn hàng",
  "payment_method": "Phương thức thanh toán",
  "emailNotNullError": "Email không được để trống",
  "orderCreateLoading": "Đang tạo đơn hàng...",
  "emailNote": "Liên hệ",
  "emailMessage": "Vui lòng đảm bảo địa chỉ email của bạn chính xác và không có lỗi. Chúng tôi sẽ gửi email xác nhận đơn hàng cho bạn.",
  "payment_method_message": "Tất cả giao dịch đều được đảm bảo an toàn và được mã hóa.",
  "go_buy_goods": "Tiếp tục mua hàng",
  "tap_cancel_order": "Nhấp vào đây để hủy đơn hàng",
  "order_review": "Đánh giá đơn hàng",
  "Add_new_address": "Thêm địa chỉ mới",
  "promo_code_type_3": "Voucher tặng khi đạt mốc",
  "IdCardNotNull": "Vui lòng điền thông tin đầy đủ",
  "UploadVideo": "Tải lên video",
  "video": "Video",
  "UploadImage": "Tải lên hình ảnh",
  "uploadImageing": "Đang tải lên...",
  "BillingInfoNotNull": "Thông tin hóa đơn không đầy đủ",
  "promo_code_type_2": "Phiếu giảm giá",
  "UploadError": "Tải lên thất bại",
  "promo_code_type_4": "Voucher giảm phí vận chuyển",
  "image": "Hình ảnh",
  "paymentMethodNotNull": "Vui lòng chọn phương thức thanh toán",
  "promo_code_type_1": "Phiếu giảm giá theo tỷ lệ phần trăm",
  "shippingInfoNotNull": "Thông tin vận chuyển không đầy đủ",
  "reviewDetail": "Chi tiết đánh giá",
  "DeliveryCountry": "Khu vực giao hàng",
  "prompt_error": "Lỗi nhắc",
  "save_review_success": "Nhận xét thành công",
  "ORDER_COMPLETED": "Đã hoàn thành",
  "crate_after_sales": "Tạo bán hàng sau",
  "Thank_You_Order": "Cảm ơn đơn đặt hàng của bạn!",
  "Thank_You_Order_sub": "Chúng tôi sẽ bắt đầu xử lý đơn đặt hàng của bạn trong thời gian sớm nhất. Bạn sẽ nhận được một email về việc xử lý đơn đặt hàng. ",
  "BootomCookieContext": "Trang web này sử dụng cookie để giúp trang web hoạt động bình thường và giúp chúng tôi hiểu cách tương tác với nó. Chúng tôi sử dụng cookie này để cung cấp trải nghiệm người dùng cá nhân tốt hơn cho bạn. Nếu bạn tiếp tục sử dụng trang web này, chúng tôi s",
  "order_reivice_message": "Bạn đã nhận được hàng chưa?",
  "order_reivice_btn": "Xác nhận nhận hàng",
  "order_reivice_label": "Đơn hàng nhận",
  "order_reivice_success": "Xác nhận nhận hàng thành công",
  "collpase_show": "Xem thêm",
  "collpase_hide": "Thu gọn",
  "CouponCode": "Mã Giảm Giá",
  "wechatPayScannerCode": "Vui lòng sử dụng ứng dụng WeChat để thanh toán bằng quét mã",
  "processing": "Đang xử lý sau bán hàng",
  "finished": "Sau bán hàng đã hoàn thành",
  "login.showPrice": "Đăng nhập để xem giá",
  "After_Sales_Unknown": "Trạng thái sau bán hàng không xác định",
  "order_payment_list_null": "Không có đơn hàng nào chờ thanh toán",
  "Cancel": "Hủy",
  "thankyou_concat": "Nếu có bất kỳ câu hỏi nào, vui lòng liên hệ với chúng tôi"
}